export var ChainType;
(function (ChainType) {
    ChainType["EVM"] = "evm";
    ChainType["SOLANA"] = "solana";
    ChainType["HYPERLIQUID"] = "hyperliquid";
})(ChainType || (ChainType = {}));
